import React, { useState, useEffect, useCallback , useRef,memo } from "react";
import {
  APIProvider,
  Map,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import {
  Box,
  TextField,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import _ from "lodash";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
//services
import { API_ENDPOINTS } from "../../Constants"; // <-- replace with your actual API key config
import useStyles from "./style";
import DispatcherApi from "Services/Dispatcher";

// components 

import BookingForm from "./Bookingform"

const DashboardHotelPage = ({ activeTab = 'book' }) => {
  const timezone = useSelector((state) => {
    const selectedTimezone = state?.timezone?.timezone || 'America/Anchorage';
    return selectedTimezone === "Asia/Coimbatore" ? "Asia/Kolkata" : selectedTimezone;
  });
  const systemlatitude = useSelector((state) => Number(state?.timezone?.latitude) || 11.127123);
  const systemlongitude = useSelector((state) => Number(state?.timezone?.longitude) || 78.656891);  
  const classes = useStyles();
  const dispatch = useDispatch();
 const [services, setservices] = useState([]);
  const [allDrivers, setalldrivers] = useState([]);  
  //map things 
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [mapCenter, setMapCenter] = useState({ lat: systemlatitude , lng: systemlongitude });
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");

   const getservicesanddrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true) {
        //console.log("fetched active service data from header--->",res?.data?.data?.serviceTypeDetails)
        setservices(res?.data?.data?.serviceTypeDetails);
      } else {
        setservices([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch service and drivers data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    const params = {};
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getdriversandservices(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getservicesanddrivers();
  }, [getservicesanddrivers]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo({ lat: systemlatitude, lng: systemlongitude });
    } else {
      setMapCenter({ lat: systemlatitude, lng: systemlongitude });
    }
    getservicesanddrivers();
  }, [systemlatitude, systemlongitude]);   

const libraries = ["places", "drawing" , 'routes'];

// Direction rendering component 
const Directions = memo(({ origin, destination }) => {
const map = useMap();
const routesLibrary = useMapsLibrary("routes");
const [directionsRenderer, setDirectionsRenderer] = useState(null);

useEffect(() => {
if (!origin || !destination) return;

if (!directionsRenderer) {
  const newDirectionsRenderer = new routesLibrary.DirectionsRenderer({ map });
  setDirectionsRenderer(newDirectionsRenderer);
}

const directionsService = new routesLibrary.DirectionsService();

directionsService.route({
    origin,
    destination,
    travelMode: "DRIVING",
  })
  .then((response) => {
    directionsRenderer?.setDirections(response);
  })
  .catch((error) => console.error("Error fetching directions:", error));

return () => {
  directionsRenderer?.setMap(null);
};
}, [origin, destination, map, routesLibrary, directionsRenderer]);

return null;
});

  return (
    <>
      <Box sx={{ minHeight: 'calc(100vh - 105px)',
 height: { xs: "auto", md: "calc(100vh - 68px)" }, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflow: { xs: 'visible', md: 'hidden' }, background: '#f8fafc', padding: { xs: 2, md: 4 } }}>
        <APIProvider 
          apiKey={API_ENDPOINTS.GMAP_API} 
          libraries={libraries}
        >
          <React.Fragment>
            <Grid container sx={{ height: { xs: 'auto', md: '100%' },minHeight: 'calc(100vh - 140px)', 
              width: '100%', maxWidth: '1440px', margin: "-50px auto 0", overflow: { xs: 'visible', md: 'hidden' } }} spacing={4}>
              
              {/* Left Side Booking Form - 38% Width on Desktop, Full Width on Mobile */}
              <Grid item sx={{ width: { xs: '100%', md: '38%' }, height: { xs: 'auto', md: '100%' }, display: 'flex', flexDirection: 'column', order: { xs: 2, md: 1 } }}>
                <BookingForm 
                  userType={userType}
                  setOrigin={setOrigin}
                  setDestination={setDestination}
                  origin={origin} destination={destination}
                  setMapCenter={setMapCenter}
                  services={services}
                  timezone={timezone}
                  activeTab={activeTab}
                />
              </Grid>         

              {/* Right Side Map - 62% Width on Desktop, Fixed Height on Mobile */}
              <Grid item sx={{ width: { xs: '100%', md: '62%' }, height: { xs: '400px', md: '100%' }, display: 'flex', flexDirection: 'column', overflow: 'hidden', order: { xs: 1, md: 2 } }}>
                <Box sx={{ flex: 1, width: '100%', borderRadius: 4, overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.08)' }}>
                  <Map
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    defaultCenter={mapCenter}
                    defaultZoom={10}
                    gestureHandling={"greedy"}
                    mapId={"40e581fce79a8421a2f62ee2"}
                    onLoad={(map) => (mapRef.current = map)}
                  >
                    <Directions origin={origin} destination={destination} />
                  </Map>
                </Box>
              </Grid>

            </Grid>
          </React.Fragment>      
        </APIProvider>
      </Box>
    </>
  );
};

export default DashboardHotelPage;

